export default __webpack_public_path__ + "static/2019-7ba0477621edcf2ac8ba1beb7ea61e11.jpg";